<div *ngIf="errorMessage" class="copo-error-banner" role="alert" aria-live="polite">
	<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-error-icon"></mat-icon>
	<div class="copo-error-content">
		<div class="copo-error-title" translate>{{ errorTitle || 'quapp.error' }}</div>
		<div>{{ errorMessage }}</div>
	</div>
</div>
